import React from 'react';
import { motion } from 'framer-motion';
import { PlayCircle, ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen flex flex-col items-center justify-center overflow-hidden px-4 py-12 md:py-20 bg-zinc-950" data-id="element-72" data-mp="eibpplxscw9g">
      {/* Background Video/Glow */}
      <div className="absolute inset-0 z-0 flex items-center justify-center opacity-20" data-id="element-73" data-mp="4mru70n4vzl8">
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950 via-transparent to-zinc-950 z-10" data-id="element-74" data-mp="129qv5nkuztox" />
        <video autoPlay loop muted playsInline className="w-full h-full object-cover" data-id="element-75" data-mp="xbfkxbqnjh66">
          <source src="https://cdn.magicpatterns.com/uploads/55KnTbRTivKPf69boyz6W6/labs-003.mp4" type="video/mp4" data-id="element-76" data-mp="sd4aaysj92mw" />
        </video>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center mt-8 md:mt-12" data-id="element-77" data-mp="3d1sayygxbltn">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-amber-500/10 border border-amber-500/20 text-amber-400 text-sm font-medium mb-8" data-id="element-78" data-mp="381xmf1kmf8br">
          <span className="w-2 h-2 rounded-full bg-amber-500 animate-pulse" data-id="element-79" data-mp="39b4h50y9lu2x" />
          Para creadores, emprendedores y dueños de negocio que aún pagan de más por sus anuncios
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-5xl md:text-7xl font-bold text-white tracking-tight leading-tight mb-8" data-id="element-80" data-mp="30hrf99i83i4p">
          El Mismo Anuncio Que Tu Agencia Te Cobra <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-amber-600" data-id="element-81" data-mp="2vjzq2n8yqa47">$3,000</span>… Ahora Lo Creas Tú Solo en 15 Minutos
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl md:text-2xl text-zinc-400 mb-8 md:mb-12 max-w-3xl mx-auto" data-id="element-82" data-mp="2lkiks6xmhy8r">
          Y cuando descubras lo fácil que era, vas a sentir un nudo en el estómago por todo el dinero que ya quemaste.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="w-full max-w-4xl mx-auto mb-8 md:mb-12 rounded-2xl overflow-hidden border border-zinc-800 shadow-[0_0_40px_rgba(245,158,11,0.15)] relative z-20 bg-zinc-950" data-id="element-83" data-mp="dd5ews2mzp5p">
          <div style={{
          position: 'relative',
          paddingTop: '56.25%'
        }} data-id="element-84" data-mp="111esj6pp56lr">
            <iframe src="https://embed.fliki.ai/embed/6a790feca38050694d9dd8d9" loading="lazy" style={{
            border: 0,
            position: 'absolute',
            top: 0,
            height: '100%',
            width: '100%'
          }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen={true} data-id="element-85" data-mp="x1nvil9ktu8s"></iframe>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-86" data-mp="21a4ohgz55rz4">
          <a href="#pricing" className="group relative inline-flex items-center justify-center gap-3 px-8 py-4 bg-amber-500 text-zinc-950 font-bold rounded-xl overflow-hidden transition-transform hover:scale-105 active:scale-95 w-full sm:w-auto" data-id="element-87" data-mp="2b2sk48edxpw9">
            <div className="absolute inset-0 bg-white/20 translate-y-full group-hover:translate-y-0 transition-transform" data-id="element-88" data-mp="2p08v7x7mm7uc" />
            <span data-id="element-89" data-mp="2tz1y6vpaegg9">QUIERO EL PROTOCOLO AHORA</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-90" data-mp="umpopxvmbeww" />
          </a>
          <div className="flex items-center gap-2 text-sm text-zinc-500" data-id="element-91" data-mp="zl0zqbxnfvgp">
            <PlayCircle className="w-4 h-4" data-id="element-92" data-mp="zndp3a5ql83s" />
            <span data-id="element-93" data-mp="4acmjdl07r7y">Acceso inmediato · Sin suscripción</span>
          </div>
        </motion.div>
      </div>
    </section>;
}